import {
  CommonParamsType,
  CommonSuccessResponse,
} from "constants/types/common";
import { ProductCategoryResponse } from "constants/types/productCategory";
import useSWR from "swr";
import { serialize } from "utils/validation/string";

export const getProductCategoryListKey = (params?: CommonParamsType) => {
  return `/product-category?${serialize({ ...params })}`;
};

export const useProductCategories = (params?: CommonParamsType) => {
  const {
    data,
    error,
    isLoading,
    mutate,
  }: {
    data: CommonSuccessResponse<ProductCategoryResponse[]> | undefined;
    error: any;
    isLoading: boolean;
    mutate: any;
  } = useSWR(getProductCategoryListKey(params), { refreshInterval: 0 });

  const pagination = data?.meta;
  const productCategories = data?.data;

  return {
    productCategories,
    pagination,
    error,
    isLoading,
    mutate,
  };
};

export const useListProductCategory = () => {
  const {
    data,
    error,
    isLoading,
    mutate,
  }: {
    data: CommonSuccessResponse<ProductCategoryResponse[]> | undefined;
    error: any;
    isLoading: boolean;
    mutate: any;
  } = useSWR("/product-category/all", { refreshInterval: 0 });

  const productCategoryList = data?.data;

  const productCategoryOptions = productCategoryList?.map((item) => ({
    label: item.name,
    value: item.id,
  }));

  return {
    productCategoryOptions,
    error,
    isLoading,
    mutate,
  };
};
